<template>
  <div class="st-smart-search">
    <!-- Search Box -->
	<input type="text" v-model="searchTermTmp" class="form-control" :placeholder="wpData.placeholder">
    <!-- AppGetPosts Component -->
	<p style="position: absolute;
    top: 0px;
    transform: translatey(-50%);
    left: 50%;"
		class="apiResponse text-center"
		v-html="apiResponse" />
    <app-get-posts
      :search-term="searchTerm"
    />
  </div>
</template>
<script>
import AppGetPosts from './AppGetPosts';

export default {
	components: {
		'app-get-posts': AppGetPosts
	},
	data() {
		/*global wpData:true*/
		/*eslint no-undef: "error"*/
		return {
			searchTerm: '',
			searchTermTmp: '',
			wpData,
			timing: null
		};
	},
	watch: {
		searchTermTmp: function (newQuestion, oldQuestion) {
			this.timing = setTimeout(() => {
				if (this.searchTerm !== this.searchTermTmp) 
					this.searchTerm = this.searchTermTmp
			}, 1000)
		}
	},
	beforeUnmount() {
		clearTimeout(this.timing)
	},
};
</script>

<style scoped>
	.st-smart-search{
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/AppQuickSearch.vue